import {Observable, throwError as observableThrowError} from 'rxjs';
import {Injectable} from '@angular/core';
import {CustomHttp} from "../../core/http-custom/http-custom.service";
import {ImageModel} from "app/shared/models/image.model";
import {CustomerModel} from "app/customer/models/customer-model";
import {catchError} from 'rxjs/operators';

@Injectable()
export class CustomerService {

  constructor(
    private _http: CustomHttp
  ) {
  }

  public getCustomerByCustomerNumber(term: string) {
    return this._http.get<CustomerModel>(`/apps/umng/api/customer/${term}`);
  }

  public getCustomerByCustomerNumberWithValidation(term: string) : Observable<CustomerModel> {
    return this._http.get<CustomerModel>(`/apps/umng/api/customer/validate/${term}`).pipe(
      catchError( (error: any) => {
        return observableThrowError(error);
      })
    );
    //   .catch((err:Response) =>{
    //   return observableThrowError(err);
    // });
  }

  public getCurrentCustomer(): Observable<CustomerModel> {
    return this._http.get(`/apps/umng/api/customer`);
  }

  public saveCustomerChanges(customer: CustomerModel, upload?: ImageModel, attachmentId?: number, removeLogo?: boolean): Observable<any> {
    return this._http.post(`/apps/umng/api/customer`,
      {
        customer: customer,
        logo: upload,
        attachmentId: attachmentId,
        removeLogo: removeLogo
      });
  }
}
